import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../mobile.setup';
import { MobileStatisticsGrowthTab } from './tabs';

const parent = Mobile.pages.statistics;
const title = 'PAGE.MOBILE.STATISTICS.TITLE';
const tabs: TabPermission[] = [MobileStatisticsGrowthTab];

export const MobileStatisticsPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
